(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["header-2"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

 const triggerTabList = document.querySelectorAll('#myTab .nav-link')
    triggerTabList.forEach(triggerEl => {
      const tabTrigger = new bootstrap.Tab(triggerEl);   
      
      triggerEl.addEventListener('mouseover', event => {
        event.preventDefault()
        tabTrigger.show()
        var tempoffcanvasid = $(triggerEl).attr('data-offcanvas-id');
         $('.suboffcanvas .subtab-'+tempoffcanvasid ).addClass('show').siblings().removeClass('show');
        
      })
    });

  const tempmenuover = $('.header__inline-menu li ');
  tempmenuover.mouseover(function() {    
        event.preventDefault()
        $('.offcanvasExample').addClass('show').css({"visibility":"visible"});
        $('header').append("<div class='offcanvas-backdrop fade show'>.</div>");
      });
  $(".offcanvas-btn-close").click(function(){
    $('.offcanvasExample').removeClass('show').css({"visibility":"hidden"});
     $('header .offcanvas-backdrop').remove();
  });

  $('#myTabContent .nav-link').mouseover(function(){
    var tempid = $(this).attr("data-offcanvas-id");
    $('.suboffcanvas .subtab-'+tempid ).addClass('show').siblings().removeClass('show');
    
  });

  $(document).click(function(event){
	          var _con = $('.offcanvasExample');   // 设置目标区域
	          if(!_con.is(event.target) && _con.has(event.target).length === 0){ 
    	        $('.offcanvasExample').removeClass('show').css({"visibility":"hidden"});
                 $('header .offcanvas-backdrop').remove();
	          }
	    });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-list"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
  $('.logo-slider').slick({
  infinite: true,
  autoplay: true,
  autoplaySpeed:1000,
  speed: 1000,
  slidesToShow: 8,
  slidesToScroll: 8,
  fade: false,
  adaptiveHeight: false,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow: 8,
        slidesToScroll: 8,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 6,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: false
    }
    }
  ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

  $('.product__accordion').click(function(obj){
     var tempopen = $(this).find('.product__accordion_Details').attr('open');
    $.each($(this).siblings('.product__accordion'),function(index,value){
      $(value).removeClass('show_collaps');
      $(value).find(".product__accordion_Details").attr('open',false);
    }); 
    if(tempopen =='open'){
      $(this).removeClass('show_collaps');
    }else{
      $(this).addClass('show_collaps');
    }
  });

  
  var viewheight= $(".thumbnail-list").height();  
  var ulheight = $(".thumbnail-list-ul").height();
  $(".slider-button--next").attr("disabled",false);
  $(".slider-button--prev").attr("disabled",false);
  var translateY = 0;
  $(".slider-button--next").click(function(){
    var ulposition = parseInt($(".thumbnail-list-ul").css('transform').split(',')[5]);
    if(ulposition+ ulheight -viewheight>viewheight  ){
       translateY = ulposition-viewheight;
     }else{
       translateY = viewheight-ulheight;
       //$(".slider-button--next").attr("disabled",true);
     }
    
    console.log(viewheight,ulposition,ulheight,translateY);
    $(".thumbnail-list-ul").css("transform",'translateY('+translateY+'px)');
  });
   $(".slider-button--prev").click(function(){
     var ulposition = parseInt($(".thumbnail-list-ul").css('transform').split(',')[5]);
     console.log(ulposition,ulheight,viewheight,translateY);
     if(viewheight+ulposition>=0){
      translateY = 0;
      // $(".slider-button--next").attr("disabled",true);
    }else{
      translateY = ulposition+viewheight;
    }
      $(".thumbnail-list-ul").css("transform",'translateY('+translateY+'px)');
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-swiper-show"] && !window.DesignMode) return;
  try {
      
  $(".slider-counter--current").bind("DOMNodeInserted",function(){    
      var temptotal = $(this).siblings(".slider-counter--total").text();
      var temppage = $(this).text();
      var tempsize = 500/temptotal*(temppage-1);
    //console.log(temptotal,temppage,  tempsize );
    console.log($(this).parent().siblings("div.slider-scrollbar-box").find(".slider-scrollbar-drag" ) );
      $(this).parent().siblings("div.slider-scrollbar-box").find(".slider-scrollbar-drag" ).css({'transform': 'translate3d('+tempsize+'%,0px,0px)'});
  });
  
  } catch(e) { console.error(e); }
})();
      })();
